import { css } from '@firebolt-dev/css'
import { useEffect, useRef, useState } from 'react'
import { isTouch } from '../utils'

export function ChatWindow({ world, x, y, w, h, onClose }) {
  const [messages, setMessages] = useState(() => world.chat.messages)
  const [draft, setDraft] = useState('')
  const bottomRef = useRef()

  useEffect(() => {
    function onChat(messages) {
      setMessages([...messages])
    }
    world.on('chat', onChat)
    return () => world.off('chat', onChat)
  }, [])

  useEffect(() => {
    bottomRef.current?.scrollIntoView()
  }, [messages])

  function send() {
    if (draft === '/stats') {
      world.emit('toggleStats')
      setDraft('')
      return
    }
if (draft.startsWith('/admin ')) {
      world.send({ type: 'admin', password: draft.slice(7) })
      setDraft('')
      return
    }
    if (draft === '/mute') {
      world.audio.toggleMute()
      setDraft('')
      return
    }
    if (draft.startsWith('/')) {
      setDraft('')
      return
    }
    world.chat.send(draft)
    setDraft('')
  }

  return (
    <div
      className='chat'
      css={css`
        position: absolute;
        top: ${y}px;
        left: ${x}px;
        width: ${w}px;
        height: ${h}px;
        display: flex;
        flex-direction: column;
        pointer-events: auto;
        .chat-inner {
          flex: 1;
          overflow-y: auto;
          font-size: 5px;
          line-height: 1.2;
          color: white;
          padding: 3px 3px 1px;
        }
        .chat-name {
          opacity: 0.7;
        }
        .chat-input {
          width: 100%;
          font-size: 5px;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          outline: none;
          color: white;
          padding: 3px 3px;
          &::placeholder {
            color: #60707d;
          }
        }
      `}
    >
      <div className='chat-inner noscrollbar'>
        {messages.map((msg, i) => (
          <div key={i}>
            <span className='chat-name'>{msg.name}: </span>
            {msg.text}
          </div>
        ))}
        <div ref={bottomRef} />
      </div>
      <input
        className='chat-input'
        type='text'
        placeholder='Say something...'
        value={draft}
        onChange={e => setDraft(e.target.value)}
        autoFocus={!isTouch}
        onKeyDown={e => {
          if (e.code === 'Enter') draft ? send() : onClose()
          if (e.code === 'Escape') onClose()
          e.stopPropagation()
        }}
      />
    </div>
  )
}
